import ExternalContentCreateContainer from '@src/components/externalcontent/create/ExternalContentCreateContainer';
import React from 'react';

const ExternalContentCreatePage = () => <ExternalContentCreateContainer />;

export default ExternalContentCreatePage;
